import Loader from "components/loader";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAllStatistics } from "../../../axios/api";
import { convertToDDMMYYYYWithTime } from "utils/utils";

const Statistics = () => {
  const [loading, setLoading] = useState(false);
  const [statisticsData, setStatisticsData] = useState<any>();

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        setLoading(true);
        const statDataResp = await getAllStatistics();

        if (statDataResp?.data?.data?.stats[0]) {
          statDataResp.data.data.stats[0].updatedAt = convertToDDMMYYYYWithTime(
            statDataResp.data.data.stats[0].updatedAt?.slice(0, 10) +
              " " +
              statDataResp.data.data.stats[0].updatedAt.slice(11, 19)
          );
        }

        const dataMapping: any = {
          updatedAt: "Updated At",
          ws_conducted: "Workshops Conducted",
          ws_beneficieries: "Workshop Beneficieries Covered",
          ws_male: "Workshop Male Participants",
          ws_female: "Workshop Female Participants",
          sfd_ws_conducted: "Special Focused Districts Workshops Conducted",
          sfd_ws_beneficieries:
            "Special Focused Districts Beneficieries Covered",
          elms_total_registrations: "ELMS Total Registrations",
          nflat_total_school_registered: "NFLAT Total Schools Registered",
          nflat_total_student_registered: "NFLAT Total Students Registered",
          mssp_conducted: "MSSP Conducted",
          mssp_students_reached: "MSSP Students Reached",
        };

        const transformedData = Object.keys(
          statDataResp?.data?.data?.stats[0]
        ).map((key) => ({
          label: dataMapping[key],
          value: statDataResp?.data?.data?.stats[0][key],
        }));

        const rearrangedStatData = [
          transformedData[11],
          ...transformedData.slice(0, 11),
        ];

        setStatisticsData(rearrangedStatData);
        if (!statDataResp?.data?.success) {
          toast.error("Error Fetcing statistics");
          console.log("statDataResp", statDataResp);
        }
      } catch (error) {
        toast.error("Error Fetcing statistics");
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStatistics();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="h-full rounded-md bg-white">
        <div className="flex justify-between p-4">
          <span className="text-2xl font-bold">Statistics</span>
        </div>
        <div>
          {statisticsData && statisticsData.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="border-slate-500 w-full border text-left text-sm text-gray-500">
                <thead className="bg-gray-300 text-xs uppercase text-gray-700">
                  <tr>
                    {/* <th
                      scope="col"
                      className="border-slate-500 border px-6 py-3"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="border-slate-500 border px-6 py-3"
                    >
                      Statistics
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {statisticsData.map((data: any) => (
                    <tr className="bg-white">
                      <th
                        scope="row"
                        className="border-slate-500 font-large whitespace-nowrap border px-6 py-4 text-gray-900"
                      >
                        {data.label}
                      </th>
                      <td className="border-slate-500 border px-6 py-4 font-medium text-gray-900">
                        {data.value as string}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="flex min-h-[80vh] items-center justify-center text-4xl	font-bold	">
              {!loading ? "No Statistics Found" : ""}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Statistics;
